class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onMobileColorCheckboxChange =
      this.onMobileColorCheckboxChange.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener("change", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    // Set up event listeners for mobile color checkboxes
    this.setupMobileColorCheckboxListeners();
  }

  static isDesktop() {
    return window.innerWidth >= 990;
  }

  static reloadIfDesktop() {
    if (FacetFiltersForm.isDesktop()) {
      window.location.reload();
    }
  }

  setupMobileColorCheckboxListeners() {
    // Use event delegation to handle mobile color checkboxes
    const mobileForm = this.querySelector("#FacetFiltersFormMobile");
    if (mobileForm) {
      mobileForm.addEventListener("change", (event) => {
        const checkbox = event.target;
        if (
          checkbox.classList.contains("mobile-facets__checkbox") &&
          checkbox.closest(".color-check")
        ) {
          this.onMobileColorCheckboxChange(event);
        }
      });
    }
  }

  onMobileColorCheckboxChange(event) {
    const checkbox = event.target;
    const label = checkbox.closest(".color-check");

    if (label) {
      // Simply toggle active class based on checked state
      if (checkbox.checked) {
        label.classList.add("active");
      }
    }
  }

  static toggleMobileFooterVisibility() {
    const checkboxes = document.querySelectorAll(
      "facet-filters-form .mobile-facets__checkbox",
    );
    const filter_footers = document.querySelectorAll(
      "facet-filters-form .mobile-facets__footer",
    );
    // Check if any checkbox is checked
    const hasCheckedCheckbox = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked,
    );
    // Toggle small-hide class on all mobile-facets__footer elements (desktop only)
    if (FacetFiltersForm.isDesktop()) {
      filter_footers.forEach((filter_footer) => {
        if (hasCheckedCheckbox) {
          filter_footer.classList.remove("small-hide");
        } else {
          filter_footer.classList.add("small-hide");
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);

    // Check for active filters immediately after the page loads
    const checkFiltersVisibility = () => {
      const mainCollectionFilters = document.getElementById(
        "main-collection-filters",
      );
      if (mainCollectionFilters) {
        const hasFilters =
          FacetFiltersForm.searchParamsInitial &&
          FacetFiltersForm.searchParamsInitial !== "";
        mainCollectionFilters.style.display = hasFilters ? "block" : "none"; // Set display based on filters
      }
    };

    // Use DOMContentLoaded to ensure the filters are displayed correctly after the page loads
    document.addEventListener("DOMContentLoaded", () => {
      checkFiltersVisibility(); // Check filters visibility immediately
      FacetFiltersForm.toggleMobileFooterVisibility(); // Check footer visibility on load
    });

    // Also check visibility on page load if there are filters
    checkFiltersVisibility();
    FacetFiltersForm.toggleMobileFooterVisibility();
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = searchParams.match(/q=&/)
      ? searchParams.replace("q=&", "q=*&")
      : searchParams;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderSortPaginate(html);
        FacetFiltersForm.renderProductCount(html);
        ISSEYMIYAKE.Search.init();
        if (typeof window.syncEcSearchFiltersFromLocation === "function") {
          window.syncEcSearchFiltersFromLocation();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderSortPaginate(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof window.syncEcSearchFiltersFromLocation === "function") {
      window.syncEcSearchFiltersFromLocation();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  /** Refresh head/foot pagination so page links keep current filter params (mobile AJAX). */
  static renderSortPaginate(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const head = parsedHTML.getElementById("storeitems_head");
    if (!head) return;

    const headPaging = head.querySelector("._paging");
    const headPageNumber = head.querySelector("._pageNumber");
    if (!headPaging || !headPageNumber) return;

    const headPagingHtml = headPaging.innerHTML;
    const headPageNumberHtml = headPageNumber.innerHTML;

    const updateContainer = (containerId) => {
      const container = document.getElementById(containerId);
      if (!container) return;
      const paging = container.querySelector("._paging");
      const pageNumber = container.querySelector("._pageNumber");
      if (paging) paging.innerHTML = headPagingHtml;
      if (pageNumber) pageNumber.innerHTML = headPageNumberHtml;
    };

    updateContainer("storeitems_head");
    updateContainer("storeitems_foot");
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.toggleMobileFooterVisibility();

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
      FacetFiltersForm.toggleMobileFooterVisibility();
      FacetFiltersForm.reloadIfDesktop();
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
      FacetFiltersForm.reloadIfDesktop();
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const pillText =
      typeof window.getFacetPillLabelFromLink === "function"
        ? window.getFacetPillLabelFromLink(link)
        : link
            .querySelector(".active-facets__button-inner")
            ?.textContent?.trim();

    if (
      typeof window.removeSearchFacetPillAndRender === "function" &&
      pillText
    ) {
      window.removeSearchFacetPillAndRender(pillText, link);
      return;
    }

    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    if (form) {
      form.onActiveFilterClick(event);
      FacetFiltersForm.reloadIfDesktop();
    }
  }
}

customElements.define("facet-remove", FacetRemove);
